<div>
<div class="pure-menu pure-menu-horizontal">
  <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Add/Remove Overrides</a>
</div>
    <div class="container">
    <!-- Update Config Form-->
    <form [hidden]="loading" [formGroup]="updateTransitTimeOverridesForm" (ngSubmit)="submit()" class="pure-form pure-form-stacked">
  
         <!-- Select option for From Country Code Options -->
    <div class="pure-control-group">
        <label for="fromCountryCodeId">From Country Code <app-popover [message]="help_messages.from_country_code"></app-popover></label>
        <select id="fromCountryCodeId" class="pure-input-2-3"
                formControlName="fromCountryCode" #fromCountryCode (change)="onFromCountryCodeChange(fromCountryCode.value)">
          <option *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
                  [value]="_fromCountryCode">
            {{ _fromCountryCode }}
          </option>
        </select>
    </div>
  
    <div class="pure-control-group">
        <label for="businessUseCase">Business Use Case  <app-popover [message]="help_messages.business_unit"></app-popover></label>
        <select name="businessUseCase" id="businessUseCase" class="pure-input-2-3" formControlName="businessUseCase" #businessUseCaseRef (change)="onBusinessUseCaseChange(businessUseCaseRef.value)">
          <ng-template ngFor let-item [ngForOf]="items">
            <optgroup label="{{item.name}}">
              <option *ngFor="let usecase of item.usecases" [value]="usecase.value">
                {{usecase.text}}
              </option>
            </optgroup>
          </ng-template>
        </select>
    </div>

    <!-- Read only text for displaying onboarded component key placeholder-->
    <label for="componentKeyPlaceholderId">Level Of Data  <app-popover [message]="help_messages.level_of_data"></app-popover></label>
    <input id="componentKeyPlaceholderId" class="pure-input-2-3" type="text"
           formControlName="componentKeyPlaceholder" readonly/>

    <!-- Dynamic entries for Component Key Place holder parts -->
    <form [formGroup]="updateTransitTimeOverridesForm.get('componentKeyValue')">
      <div *ngFor="let field of currentComponentKeyPlaceholder;let i = index">
        <label for="{{'componentKeyValue'+i}}">{{field}}</label>
        <select type="text" [formControlName]="field" class="pure-input-2-3" id="{{'componentKeyValue'+i}}">
          <option *ngFor="let option of dropDownOptions[field]" [value]="option">
            {{option}}
          </option>
        </select>
      </div>
    </form>

    <div [hidden]="singleTransitTimeColumns.length == 0">
        <label for="schema">Required Schema Format of the Transit Time Files for the selected Business use case
          <app-popover [message]="help_messages.expected_schema"></app-popover>
        </label>
        <div id="schema" class="p-3 mb-2 text-dark" >
          <app-table [label]="single" [header]="singleTransitTimeColumns"></app-table>
          <app-table [label]="range" [header]="rangeTransitTimeColumns"></app-table>
        </div>
    </div>
  
      <!-- Select option for adding or removing overrides-->
    <label for="updateOverridesTypeId">Update Type</label>
    <select formControlName="updateOverridesType" id="updateOverridesTypeId" class="pure-input-2-3">
        <option *ngFor=" let _updateOverridesType of updateOverridesTypeOptions; let i = index " [value]="_updateOverridesType">
          {{ _updateOverridesType }}
        </option>
    </select>
  
    <div>
        <label for="fileUpload">Upload File</label>
        <input type="file" formControlName="transitTimeOverridesFile" class="pure-input-2-3" id="fileUpload" accept=".tsv" (change)="onFileChange($event)">
    </div>
  
      <!-- Submit button-->
    <div>
        <button class="pure-button pure-button-primary button-large" type="submit"
                [disabled]="updateTransitTimeOverridesForm.invalid || (progress > 0 && progress < 100)">Submit
        </button>
    </div>
    </form>
    <div class="progress" *ngIf="progress > 0">
      <div class="progress-bar progress-bar-animated progress-bar-striped bg-success" role="progressbar" [style.width.%]="progress">{{progress}}%</div>
    </div>
    <app-loader [loading]="loading" [size]="'small'"></app-loader>
    </div>

</div>